"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubCategory = void 0;
var SubCategory;
(function (SubCategory) {
    SubCategory["PAYMENT"] = "payment";
    SubCategory["BUDGET_BILL_AMOUNT"] = "budget_bill_amount";
    SubCategory["YEAR_BILL"] = "yearly_bill";
    SubCategory["FINAL_BILL"] = "final_bill";
    SubCategory["CORRECTION"] = "correction";
    SubCategory["METER_READING_ANNUAL"] = "meter_readings_annual";
    SubCategory["INFO_PAYMENT"] = "info_payment";
    SubCategory["PAYMENT_ARREARS"] = "payment_arrears";
    SubCategory["OFFER"] = "offer";
    SubCategory["CANCEL_OFFER"] = "cancel_offer";
    SubCategory["CHANGE_LOGON"] = "change_logon";
    SubCategory["CONTRACT_STATUS"] = "contract_status";
    SubCategory["METER_READING_START"] = "meter_readings_start";
    SubCategory["COMPENSATION_CANC_FEE"] = "compensation_canc_fee";
    SubCategory["UNJUSTIFIED_REGISTRATION"] = "unjustified_registration";
    SubCategory["MOVE"] = "move";
    SubCategory["CHANGE_MOVE_DATE"] = "change_move_data";
    SubCategory["MOVE_STATUS"] = "move_status";
    SubCategory["METER_READINGS_MOVE"] = "meter_readings_move";
    SubCategory["LIVING_IN_WITH_NON_CUSTOMER"] = "living_in_with_non_customer";
    SubCategory["EMIGRATION"] = "emigration";
    SubCategory["END_OF_SUPPLY"] = "end_of_supply";
    SubCategory["STATUS_CANCELLATION"] = "status_cancellation";
    SubCategory["DECEASED"] = "deceased";
    SubCategory["CANCELLATION_FEE"] = "cancellation_fee";
    SubCategory["METER_READING_TERMINATION"] = "meter_reading_termination";
    SubCategory["VACANCY"] = "vacancy";
    SubCategory["DIVORCE"] = "divorce";
    SubCategory["OVERLAP_SITUATION"] = "overlap_situation";
    SubCategory["ONE_OVERLAP_SITUATION"] = "1-overlap_situation";
    SubCategory["LIVING_IN_WITH_CUSTOMER"] = "living_in_with_customer";
    SubCategory["MOVEOUT_WITHOUTREASON"] = "moveout_withoutreason";
    SubCategory["CHANGE_PERSONAL_DATA"] = "change_personal_data";
    SubCategory["CONTRACT_CANCELLED"] = "contract_cancelled";
    SubCategory["CHANGE_PAYMENT_DETAILS"] = "change_payment_details";
    SubCategory["CHANGE_CONTRACT_DETAILS"] = "change_contract_details";
    SubCategory["CHANGE_PRIVACY_SETTINGS"] = "change_privacy_settings";
    SubCategory["OTHER_PRIVACY_QUESTIONS"] = "other_privacy_questions";
    SubCategory["CONSUMPTION_AND_SAVING"] = "consumption_and_saving";
    SubCategory["METER"] = "meter";
    SubCategory["OFFER_COMFORT"] = "offer_comfort";
    SubCategory["PRODUCTS_SERVICES"] = "products_services";
    SubCategory["CONSUMPTION_FEEDBACK"] = "consumption_feedback";
    SubCategory["EMOBILITY"] = "emobility";
    SubCategory["METER_READINGS_VALIDATION"] = "meter_readings_validation";
    SubCategory["VALIDATION_METERREADING"] = "meter_readings_validation";
    SubCategory["ONE_CALAMITY"] = "1-calamity";
    SubCategory["TWO_CALAMITY"] = "2-calamity";
    SubCategory["CALAMITY"] = "calamity";
    SubCategory["MOBILE_APP"] = "mobile_app";
    SubCategory["SELF_SERVICE_PORTAL"] = "self_service_portal";
    SubCategory["ONE_SELF_SERVICE_PORTAL"] = "1-self_service_portal";
    SubCategory["LOGIN_SELF_SERVICE_PORTAL"] = "login_self_service_portal";
    SubCategory["ONE_LOGIN_SELF_SERVICE_PORTAL"] = "1-login_self_service_portal";
    SubCategory["SERVICEAPP"] = "serviceapp";
    SubCategory["CORRESPONDENCE"] = "Correspondence";
    SubCategory["DEPOSIT_REQUIRED"] = "deposit_required";
    SubCategory["PAYMENT_DEPOSIT_NOT_ACCEPTED"] = "payment_deposit_not_accepted";
    SubCategory["SCREENING_NOT_ACCEPTED"] = "screening_not_accepted";
    SubCategory["CHANGED_TERMS"] = "changed_terms";
    SubCategory["TAKEOVER_CONTRACT"] = "takeover_contract";
    SubCategory["NEW_ADDRESS_ALREADY_REGISTERED"] = "new_address_already_registered";
    SubCategory["CANCEL_IN_COOLDOWN"] = "cancel_in_cooldown";
    SubCategory["TAKEOVER_OR_COMPANY_CLOSURE"] = "takeover_or_company_closure";
    SubCategory["HH_TO_SOHO"] = "hh_to_soho";
    SubCategory["HH_OR_SOHO_TO_SME"] = "hh_or_soho_to_sme";
    SubCategory["SME_TO_HH_OR_SOHO"] = "sme_to_hh_or_soho";
    SubCategory["NEW_ADDRESS_INCLUDES_ENERGY_COSTS"] = "new_address_includes_energy_costs";
    SubCategory["BANKRUPTCY"] = "bankruptcy";
    SubCategory["RECOVERY_ACTION"] = "recovery_action";
    SubCategory["CANCEL_ONE_PRODUCT"] = "cancel_one_product";
    SubCategory["ZAAKVOORDEEL"] = "zaakvoordeel";
    SubCategory["THUISVOORDEEL"] = "thuisvoordeel";
    SubCategory["GOEDZITTERS"] = "goedzitters";
    SubCategory["COLLECTION_VALIDATION_READINGS"] = "collection_validation_readings";
    SubCategory["CONVERSATIONAL_ROUTING"] = "conversational_routing";
    SubCategory["INFO_INSTALLMENTS"] = "info_installments";
    SubCategory["REASSESSMENT"] = "reassessment";
    SubCategory["UNKNOWN"] = "unknown";
})(SubCategory = exports.SubCategory || (exports.SubCategory = {}));
